<template>
  <v-container fluid grid-list-md>
    <v-alert v-for="(eob, i) in claim.EOB" dense type="success" :key="i">
      <span v-if="eob.code === '900' || eob.code === '901'">
        {{ eob.message }}
      </span>
      <span v-else>
        {{ $t(`adjudication_message.${eob.message}`, eob.formattedParams) }}
      </span>
    </v-alert>
  </v-container>
</template>

<script>
export default {
  props: ["claim"],
  data() {
    return {};
  },
};
</script>
